/** What an announcement renders, carried on the model's Type field. */
export enum AnnouncementDisplayType {
  ImageAndText,
  TextOnly,
  VideoAndText,
}
